<template>
  <v-container class="pa-0 ma-0 rounded-0" v-if="candidate">
    <v-row justify="center" no-gutters>
      <!-- Dialog -->
      <v-dialog persistent class="pa-0 ma-0 rounded-0" content-class="candidate-dialog" max-width="80%" v-model="dialog" @click:outside="close">
        <v-row class="rounded-0 ma-0 pa-0">
          <!-- Candidate Content -->
          <v-col cols="12" sm="12" md="4" lg="3" class="ma-0 pa-0 d-flex">
            <v-card class="candidate-dialog__left ma-0 pa-0" rounded="0">
              <v-list class="candidate-dialog__list my-0 pa-0 rounded-0">
                <v-list-item class="candidate-dialog__title ma-0 pa-2">
                  <v-list-item-avatar class="candidate-dialog__avatar">
                    <v-img :src="getAvatarPath(candidate.user)"/>
                  </v-list-item-avatar>
                  {{candidate.user.firstName}}
                  {{candidate.user.lastName}}
                </v-list-item>
                <span class="candidate-dialog__subtitle ml-4 mb-5">
                  Datos Personales
                </span>
                <v-list-item class="my-0 py-0" dense>
                  <v-list-item-icon class="mr-4">
                    <v-icon color="blue">mdi-email-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="candidate-dialog__text">
                    {{candidate.user.email}}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="my-0 py-0" dense>
                  <v-list-item-icon class="mr-4">
                    <v-icon color="blue">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="candidate-dialog__text">
                    {{candidate.user.phone}}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="my-0 py-0" dense v-if="getFlag(candidate.user.city)">
                  <v-list-item-icon class="mr-4">
                    <v-avatar class="float-left" rounded size="24">
                      <v-img :src="getCandidateFlag(candidate)" />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="candidate-dialog__text">
                    {{ getCandidateCity(candidate) }} / {{ getCandidateCountry(candidate) }}
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="my-0 py-0" dense>
                  <v-list-item-icon class="mr-4">
                    <v-icon color="blue" class="my-0 py-0">
                      mdi-account-plus
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="candidate-dialog__text">
                    {{ this.candidate.user.experience || "0" }} Año{{this.candidate.user.experience !== 1 ? "s" : "" }} de experiencia
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="my-0 py-0" dense>
                  <v-list-item-icon class="mr-4">
                    <v-icon color="blue">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle class="candidate-dialog__text">
                    {{ getBirthDate }}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
              <v-card-actions class="profile-btn">
                <v-list color="#E2F7FF">
                  <v-list-item dense class="ma-0 py-0 d-flex align-end">
                    <span class="candidate-dialog__title">Perfil Social</span>
                  </v-list-item>
                  <v-list-item dense class="ma-0 py-0">
                    <v-btn class="mr-1 ml-0" text icon color="transparent" v-if="candidate.user.networks.linkedin !== ''" :href="`https://www.linkedin.com/in/${getSocialPofile(candidate.user.networks.linkedin)}`" target="_blank">
                      <v-icon color="info">mdi-linkedin</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 ml-0" text icon color="transparent" v-if="candidate.user.networks.facebook !== ''" :href="`https://www.facebook.com/${getSocialPofile(candidate.user.networks.facebook)}`" target="_blank">
                      <v-icon color="info">mdi-facebook</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 ml-0" text icon color="transparent" v-if="candidate.user.networks.twitter !== ''" :href="`https://twitter.com/${getSocialPofile(candidate.user.networks.twitter)}`" target="_blank">
                      <v-icon medium color="info">mdi-twitter</v-icon>
                    </v-btn>
                    <v-btn class="mr-1 ml-0" text icon color="transparent" v-if="candidate.user.networks.instagram !== ''" :href="`https://www.instagram.com/${getSocialPofile(candidate.user.networks.instagram)}`" target="_blank">
                      <v-icon medium color="info">mdi-instagram</v-icon>
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-card-actions>
            </v-card>
          </v-col>

          <!-- Postulation content -->
          <v-col cols="12" sm="12" md="8" lg="9" class="ma-0 pa-0 d-flex">
            <v-card class="candidate-dialog__content" justify="center" elevation="0" rounded="0">
              <v-col cols="12" class="ma-0 pa-0">
                <!-- Tabs -->
                <v-tabs class="content-dialog__tabs" v-model="tab">
                  <!-- Slider -->
                  <v-tabs-slider class="candidate-dialog__slider"></v-tabs-slider>

                  <!-- Tab: Professional background -->
                  <v-tab class="candidate-dialog__tab" active-class="candidate-dialog__tab--active" href="#pro-profile">
                    PERFIL PROFESIONAL
                  </v-tab>

                  <!-- Tab: Current postulation -->
                  <v-tab class="candidate-dialog__tab" active-class="candidate-dialog__tab--active" href="#post-offer" v-if="!locations.includes('/candidate/profile')">
                    POSTULACIÓN ACTUAL
                  </v-tab>

                  <v-spacer class="candidate-dialog__top-bar"></v-spacer>

                  <div class="candidate-dialog__top-bar text-center">
                    <!-- Menu -->
                    <v-menu top v-if="getUser.type && getUser.type === 'organization'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                      </template>
                      <v-list class="text-caption mx-0 py-0" dense>
                        <v-list-item link>
                          <v-list-item-title>
                            <v-menu open-on-hover right offset-y class="d-flex ma-0 pa-0">
                              <template v-slot:activator="{ on, attrs }">
                                <span  v-bind="attrs" v-on="on">
                                  Mover
                                  <v-icon>mdi-chevron-right</v-icon>
                                </span>
                              </template>
                              <v-list dense>
                                <v-list-item
                                  link
                                  v-for="(item, index) in cols"
                                  :key="index"
                                  v-show="candidate.status.private !== item.status"
                                  @click="changeCol(item.status)"
                                >
                                  <v-list-item-title>
                                    {{ item.name }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="candidate.user.resume === ''" link  @click="getCV(candidate.user.resume)" target="_blank">
                          <v-list-item-title>
                            Descargar CV
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            link
                            @click="sendMail('no-context')"
                            v-if="candidate.status.private === 'sent' && offer.status !== 'close'"
                        >
                            <v-list-item-title>
                                Enviar Mensaje
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="candidate.status.private !== 'sent' && offer.status !== 'close'">
                            <v-list-item-title>
                                <v-menu
                                  open-on-hover
                                  right
                                  offset-y
                                  class="d-flex ma-0 pa-0 hola"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <span  v-bind="attrs" v-on="on">
                                            Enviar Email
                                            <v-icon>
                                                mdi-chevron-right
                                            </v-icon>
                                        </span>
                                    </template>
                                  <v-list dense>
                                    <v-list-item
                                        link
                                        :disabled="candidate.notified[candidate.status.private]"
                                        @click="sendMail(candidate.status.private)"
                                    >
                                        <v-list-item-title>
                                            {{sendMailItem}}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="sendMail('no-context')"
                                    >
                                        <v-list-item-title>
                                            Nuevo Mensaje
                                        </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                            </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <!-- Close Dialog -->
                    <v-btn class="ma-2" text icon color="transparent" @click="close">
                      <v-icon medium color="grey">mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-tabs>

                <!-- Tab content -->
                <v-tabs-items class="candidate-dialog__right" v-model="tab">
                  <!-- Tab: Perfil profesional -->
                  <v-tab-item id="pro-profile" value="tab" class="pa-7">
                    <v-container class="ma-0 pa-0" fluid>
                      <v-card flat class="nav-right-profile">
                        <v-row>
                          <!-- Profesiones -->
                          <v-col cols="12">
                            <h3 class="candidate-dialog__title text-left">Profesión</h3>
                            <v-chip
                              v-for="profession in candidate.user.professions"
                              :key="profession"
                              color="#e2f7ff"
                              class="candidate-dialog__text mr-2 ml-0 my-0"
                            >
                              {{profession}}
                            </v-chip>
                          </v-col>

                          <!-- Acerca de -->
                          <v-col cols="12">
                            <h3 class="candidate-dialog__title text-left">Acerca de</h3>
                            <span class="candidate-dialog__text">{{getInnerText(candidate.user.purpose)}}</span>
                          </v-col>

                          <!-- Áreas de conocimiento -->
                          <v-col cols="12">
                            <h3 class="candidate-dialog__title text-left">Áreas de conocimiento</h3>
                            <v-chip
                              v-for="(area, index) in candidate.user.knowledgeAreas"
                              :key="index"
                              color="#e2f7ff"
                              class="candidate-dialog__text mr-2 ml-0 my-0"
                            >
                              {{ area }}
                            </v-chip>
                          </v-col>

                          <!-- Experiencia - Oculto por inestabilidad del feature -->
                          <!-- <v-col cols="12" v-if="true">
                            <h3 class="candidate-dialog__title text-left">Experiencia laboral</h3>
                            <p class="candidate-dialog__text mb-2" v-for="(exp, index) in candidate.user.userExperiences" :key="index">
                              {{ exp.organizationName }}  <span class="ml-15">| {{ exp.position }}</span> <br>
                              {{ exp.brief }}
                            </p>
                          </v-col> -->
                        </v-row>
                        <v-card-actions class="profile-btn">
                          <v-row>
                            <v-col cols="12" class="d-flex justify-end alingn-end ma-0 pa-0">
                              <v-btn
                                class="candidate-dialog__btn ma-3"
                                :disabled="candidate.user.resume === ''"
                                color="info"
                                bottom
                                right
                                large
                                elevation="0"
                                @click="getCV(candidate.user.resume)"
                              >
                                {{ getUser.type === 'organization' ? "DESCARGAR CV" : "VER CV" }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-container>
                  </v-tab-item>

                  <!-- Tab: Postulación actual -->
                  <v-tab-item id="post-offer" value="tab" class="pa-7" v-if="!locations.includes('/candidate/profile')">
                    <v-container class="ma-0 pa-0" fluid>
                      <v-card flat class="nav-right-profile">
                        <!-- Fecha -->
                        <div class="candidate-dialog__date">
                          <h3 class="candidate-dialog__date-title">Fecha de postulación</h3>
                          <p class="candidate-dialog__date-text">{{ postulationDate }}</p>
                        </div>
                        <!-- Info -->
                        <v-row>
                          <v-col cols="12">
                            <h3 class="candidate-dialog__title text-left mb-5">Respuestas a preguntas de la postulación</h3>
                            <!-- Preguntas (no sueldo) -->
                            <div class="text-left" v-for="(item, index) in candidateAnswers" :key="index">
                              <p class="candidate-dialog__question my-2" >
                                {{ item.question }}
                              </p>
                              <p class="candidate-dialog__text my-5 body-2">
                                {{ item.answer }}
                              </p>
                            </div>

                            <!-- Expectativas sueldo
                            <div class="text-left mt-10" v-if="candidate.salary.toString() !== '0'">
                              <p class="candidate-dialog__title my-2">
                                {{ offer.questions[0].label }}
                              </p>
                              <p class="candidate-dialog__text my-5 body-2">
                                {{ offer.salary.currency }}{{ formatter(candidate.salary) }}
                              </p>
                            </div>
                            <div class="text-left mt-10" v-else>
                              <p class="candidate-dialog__question my-2">
                                {{ offer.questions[0].label }}
                              </p>
                              <p class="candidate-dialog__text my-5 body-2">
                                {{ getInnerText(candidate.answers[0]) }}
                              </p>
                            </div> -->
                          </v-col>
                          <v-col cols="12">
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import { currentImg, datetime, handleTxt } from "@/libs/mixins";

export default {
    name: "CandidateDialog",

    props: ["candidate", "offer", "cols", "dialog"],

    mixins: [datetime, currentImg, handleTxt],

    data() {
        return {
            tab: "",
            exp: 0,
            locations: "",
        };
    },

    created() {
        this.locations = location.pathname;
    },

    computed: {
        ...userComputed,
        sendMailItem() {
            const name = this.cols.find(c => this.candidate.status.private === c.status).name;
            return name.substring(0, 1) + name.toLowerCase().substring(1, name.length - 1);
        },
        isNotifiedAndStatusDiscarded() {
            return this.candidate.notified.discarded && this.candidate.status.private === "discarded";
        },
        getBirthDate() {
            if (!this.candidate.user.birthAt) return null;
            let months = [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre"
            ];
            let [year, month, day] =  this.candidate.user.birthAt.split("-");
            return `${day} / ${months[month - 1]} / ${year}`;
        },
        candidateAnswers() {
            return this.candidate.answers
                .slice(1)
                .map((answer, index) => {
                    return {
                        question: this.offerQuestions[index].label,
                        answer: this.getInnerText(answer),
                    };
                });
        },
        candidatePostulation() {
            return this.getType === "candidate" 
                ? this.candidate 
                : this.offer.postulations.find(postulation => postulation.userId === this.candidate.userId);
        },
        offerQuestions() {
            // Preguntas no eliminadas
            return this.offer.questions.slice(1).filter(question => !question.removed);
        },
        postulationDate() {
            const postulationDate = new Date(this.candidatePostulation.createdAt);
            const DD = postulationDate.getDate().toString().length === 2
                ? postulationDate.getDate()
                : `0${postulationDate.getDate()}`;
            const MM = (postulationDate.getMonth() + 1).toString().length === 2
                ? postulationDate.getMonth() + 1
                : `0${postulationDate.getMonth() + 1}`;
            const YY = postulationDate.getFullYear().toString().slice(-2);

            return `${DD}/${MM}/${YY}`;
        },
    },

    methods: {
        sendMail(context) {
            this.$emit("send", context);
        },
        formatter(value) {
            if (!this.offer.salary.currency) {
                this.offer.salary.currency = "CLP";
            }
            const formatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: this.offer.salary.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });

            return formatter.format(value);
        },
        close() {
            this.$emit("close", false);
        },
        getSocialPofile(url) {
            if (url.includes("https://") || url.includes("www") || url.includes(".com") || url.includes("http://")) {
                let destruction = url.split("/");
                return `${destruction[destruction.length - 1] !== "" ? destruction[destruction.length - 1] : destruction[destruction.length - 2]}`;
            } else if (url.includes("@")) {
                let extractions = url.substring(url.indexOf("@") + 1, url.length);
                return `${extractions}`;
            } else if (url === "") {
                return "";
            } else {
                return url;
            }
        },
        getCV(file) {
            let filename = file;
            let url = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_RESUME_PATH + filename;
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = encodeURI(url);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },
        changeCol(statusTo) {
            // Evaluar dejar aqui esto.
            if (!this.locations.includes("/organization/offer/")) {
                return;
            }
            // let indexFrom;
            // this.cols.forEach(col => {
            //     if (col.status === this.candidate.status.private) {
            //         indexFrom = col.cards.findIndex(card => card.id === this.candidate.id);
            //     }
            // });
            const emitValue = {
                to: statusTo,
                from: this.candidate.status.private,
                postId: this.candidate.id
            };

            this.$emit("changeCol", emitValue);
            // this.$store.dispatch("users/postUpdate", {
            //     offerId: this.offer.id,
            //     postulation: {
            //         id: this.candidate.id,
            //         status: {
            //             private: statusTo
            //         }
            //     }
            // }).then(() => {
            //     console.warn(`DB Saved ${Math.round(new Date().getTime() / 1000)}`);
            // }).catch(err => {
            //     console.warn(err);
            // });
        },
    },
};
</script>
